import React, {
    useState, useContext, useCallback, useMemo
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import metadata from './AddressLookupComponent.metadata.json5';
import styles from './AddressLookupComponent.module.scss';
import messages from './AddressLookupComponent.messages';

function AddressLookupComponent({
    value: address, isOpen, onResolve
}) {
    const matches = _.get(address, 'matches', []);
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});
    const handleChange = useCallback((value, changedPath) => {
        const data = { ...formData };

        _.set(data, changedPath, value);
        updateFormData(data);
    }, [formData]);

    const onCancelClick = useCallback(() => {
        const data = { cancel: true };
        return onResolve(data);
    }, [onResolve]);

    const onActionClick = useCallback(() => {
        const data = _.isEmpty(matches) ? { isEdit: true }
            : formData;
        return onResolve(data);
    }, [formData, matches, onResolve]);

    const confirmButtonText = useMemo(() => {
        return _.isEmpty(matches) ? translator(messages.editAddress)
            : translator(messages.selectAddress);
    }, [matches, translator]);

    const cancelButtonText = useMemo(() => {
        return translator(messages.cancel);
    }, [translator]);


    const dataForComponent = {
        ...formData,
        ...address
    };
    const overrideProps = {
        noRecordsContainer: {
            visible: _.isEmpty(matches)
        },
        addresslookupSearch: {
            value: translator(messages.noAddress)
        },
        addressesFound: {
            availableValues: !_.isEmpty(matches) && matches.map((singleAddress, index) => {
                return {
                    code: `${index}`,
                    name: `${singleAddress.addressLine1}, ${singleAddress.city}, ${singleAddress.state}, ${singleAddress.postalCode}, ${singleAddress.county} County`
                };
            })
        },
        RadioButtonContainer: {
            visible: !_.isEmpty(matches)
        }
    };
    const resolvers = {
        resolveClassNameMap: styles
    };
    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={translator(messages.selectAddress)} />
            <ModalBody
                contentLayout={{
                    component: 'grid'
                }}
            >

                <ViewModelForm
                    uiProps={metadata.componentContent}
                    model={dataForComponent}
                    overrideProps={overrideProps}
                    onValueChange={handleChange}
                    classNameMap={resolvers.resolveClassNameMap}
                    callbackMap={resolvers.resolveCallbackMap}
                />
            </ModalBody>
            <ModalFooter>
                <Button onClick={onCancelClick} type="secondary">
                    {cancelButtonText}
                </Button>
                <Button
                    onClick={onActionClick}
                    disabled={!_.isEmpty(matches) && _.isEmpty(formData)}
                >
                    {confirmButtonText}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

AddressLookupComponent.propTypes = {
    value: PropTypes.shape({}).isRequired,
    onResolve: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired
};

export default withAuthenticationContext(AddressLookupComponent);
